export const layoutMessages = {
  'footer.col.about': 'About',
  'footer.col.help': 'Help',
  'footer.col.service': 'Services',
  'footer.copy': '© 2024 Cross-region Mall · Demo project',
  'footer.link.afterSale': 'Returns',
  'footer.link.allProducts': 'All products',
  'footer.link.cart': 'Cart',
  'footer.link.contact': 'Contact',
  'footer.link.intro': 'About us',
  'footer.link.shipping': 'Shipping',
  'footer.logo': '✦ Cross-region Mall',
  'footer.slogan': 'Every product, beyond borders',
  'front.auth.login': 'Sign in / Register',
  'front.auth.logout': 'Log out',
  'front.brand': 'Cross-region Mall',
  'front.cart.loginHint': 'Sign in to use cart',
  'front.cart.title': 'Cart',
  'front.fav.loginHint': 'Sign in to view favorites',
  'front.fav.title': 'Favorites',
  'front.guest.hint': 'Guest · browse only',
  'front.lang.label': 'Language',
  'front.nav.admin': 'Admin',
  'front.nav.home': 'Home',
  'front.nav.products': 'All products',
  'front.searchPlaceholder': 'Search products, categories…',
  'front.notifications.title': 'Notifications',
  'front.notifications.empty': 'No notifications',
  'front.notifications.viewAll': 'View all',
  'front.user.levelDefault': 'Member',
  'front.user.roleAdmin': 'Admin',
  'front.user.roleUser': 'User',
  'layout.action.backFront': 'Storefront',
  'layout.action.logout': 'Log out',
  'layout.brand.desc': 'Management Console',
  'layout.brand.name': 'Smart Merchandising',
  'layout.user.fallback': 'Admin',
  // Notifications
  'notif.title': 'Notifications',
  'notif.all': 'All',
  'notif.unread': 'Unread',
  'notif.empty': 'No notifications',
  'notif.markAllRead': 'Mark all read',
  'notif.justNow': 'Just now',
  'notif.typeOrder': 'Order',
  'notif.typeSystem': 'System',
  'notif.typePromotion': 'Promo',
  'notif.orderShipped': 'Order Shipped',
  'notif.orderShippedDesc': 'Your order #ORD20260503002 has been shipped',
  'notif.promotion': 'Limited Offer',
  'notif.promotionDesc': 'Fresh fruits summer sale — up to 30% off!',
  'notif.system': 'System Notice',
  'notif.systemDesc': 'Platform maintenance on May 10, 2:00-4:00 AM',
  'notif.orderDelivered': 'Order Delivered',
  'notif.orderDeliveredDesc': 'Your order #ORD20260501001 has been delivered',
  'notif.reviewRemind': 'Review Reminder',
  'notif.reviewRemindDesc': 'Share your experience with the products',
};
